import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { parseString, stripWhiteSpaceToUpperCase } from '@chegg/commerce-utils';
import { ACCOUNT_TYPE, paymentMethodsToFilters } from '../../constants/PaymentTypes';
import { getString } from '../../constants/Strings';
import { getPaymentFieldLabelText, getPaymentServerErrorText } from '../../internals/PaymentForm/helpers';
import { PaymentFormDataFields } from '../../internals/UserAddress/constants';
/**
 * updates all mop descriptions to match UX.  Will need to change on the
 * back end if we want to remove this logic
 * @param mops PaymentMethodsData[]
 */
export var updateMopDescriptions = function updateMopDescriptions(mops, paymentForm, paymentErrorModal) {
  return mops.map(function (mop) {
    return updateDescription(mop, paymentForm, paymentErrorModal);
  });
};

/**
 * Takes the mop, and updates its description to match UX design. Also adds (expired) if the mop is expired.
 * @param mop PaymentMethodsData
 */
export var updateDescription = function updateDescription(mop, paymentForm, paymentErrorModal) {
  {
    var accountType = mop.accountType,
      last4 = mop.last4,
      month = mop.month,
      year = mop.year,
      billingAddress = mop.billingAddress,
      isExpired = mop.isExpired,
      description = mop.description;
    var updatedDescription = description;
    switch (accountType) {
      case ACCOUNT_TYPE.CREDIT_CARD:
      case ACCOUNT_TYPE.GOOGLE_PAY:
        updatedDescription = (getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.OBFUSCATED_CC) || getString('APP.PAYMENTDETAILS.DESCRIPTION.OBFUSCATED_CC')) + parseString(getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.EXP) || getString("APP.PAYMENTDETAILS.DESCRIPTION.".concat(stripWhiteSpaceToUpperCase(accountType))), _objectSpread({
          //@ts-ignore
          last4: last4,
          //@ts-ignore
          month: month,
          //@ts-ignore
          year: year ? year.substring(year.length - 2) : ''
        }, billingAddress));
        if (isExpired) {
          updatedDescription = "".concat(getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.EXPIRED) || getString('APP.PAYMENTDETAILS.EXPIRED'), " ").concat(updatedDescription);
        }
        break;
      case ACCOUNT_TYPE.PAYPAL_TOKEN:
        break;
      default:
        break;
    }
    return _objectSpread(_objectSpread({}, mop), {}, {
      description: updatedDescription
    });
  }
};

/**
 * Take the updated mop, looks for its place inthe original list, and replaces the original with the updated mop
 * @param mops PaymentMethodsData[] the list of mops in redux
 * @param updatedMop PaymentMethodsData the updated mop
 */
export var updatePaymentMethodsData = function updatePaymentMethodsData(mops, updatedMop) {
  return mops.map(function (existingMop) {
    return existingMop.cardId === updatedMop.cardId ? updatedMop : existingMop;
  });
};

/**
 * takes the list of mops from the getMop response and splits the yiftee from
 * non-yiftee MOPs.  (Note: Currently, only US supports yiftee.)
 * @param mops list of payment methods
 */
export var splitMops = function splitMops(mops, paymentForm, paymentErrorModal) {
  return {
    yiftee: mops.find(function (mop) {
      return isYiftee(mop);
    }) || null,
    paymentMethods: updateMopDescriptions(mops.filter(function (mop) {
      return !isYiftee(mop);
    }), paymentForm, paymentErrorModal)
  };
};

/**
 * Determine if provided mop is a yiftee mop or not
 * @param mop payment method
 */
export var isYiftee = function isYiftee(mop) {
  return mop.accountType === ACCOUNT_TYPE.GIFT_CODE;
};
export var getPaymentMethodFilters = function getPaymentMethodFilters(supportedPaymentMethods) {
  return supportedPaymentMethods.map(function (method) {
    var _paymentMethodsToFilt;
    return (_paymentMethodsToFilt = paymentMethodsToFilters.get(method)) !== null && _paymentMethodsToFilt !== void 0 ? _paymentMethodsToFilt : null;
  }).filter(function (filter) {
    return filter !== null;
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/MopOnFileState/MopOnFileState.helpers.js
// module id = 491
// module chunks = 11